import Form from './components/Form';
import withTheme from './withTheme';
import getDefaultRegistry from './getDefaultRegistry';
export { withTheme, getDefaultRegistry };
export default Form;
//# sourceMappingURL=index.js.map